export default __webpack_public_path__ + "static/media/how-it-works-1.a2a90a6e.png";